import React from 'react';

function Header(props) {
  const confirmed = (props.status == 1);

  let organiser = props.participants.find((participant) => {
    return participant.organiser;
  });

  let recipients = props.participants.filter((participant) => {
    return !participant.organiser && props.userId != participant.id;
  }).map((recipient) => {
    return recipient.name;
  })

  let intro;

  if (recipients.length) {
    let friends = recipients.join(', ').replace(/, ([^,]*)$/, ' and $1');
    intro = organiser.name + " invited you to go out with " + friends + ".";
  } else {
    intro = organiser.name + " invited you to go out.";
  }

  return (
    <React.Fragment>
      <h1 className="funky">
        { confirmed ? "All set! Have fun" : "Let's go out!" }
      </h1>
      { confirmed && <i className="material-icons md-48 confirmed">check_circle</i> }
      <p className="header">{intro}</p>
    </React.Fragment>
  );
}

export default Header;
